module.exports = __webpack_public_path__ + "static/media/calendarWhite.9b1e60b8.svg";